import OwnerCard from "components/AgentPortal/PolicyDetails/AnnuitiesPolicyCards/OwnerAndInsuredCard/OwnerCard";
import AnnuitantCard from "components/AgentPortal/PolicyDetails/AnnuitiesPolicyCards/OwnerAndInsuredCard/AnnuitantCard";

export default function OwnerAndInsuredCard({ policyDetail }) {
  const { multipleOwner: owners, multipleAnnuitants: annuitants } =
    policyDetail;
  let updated = owners.sort((a, b) =>
    a.person.type === "Primary Owner" ? -1 : 0
  );
  return (
    <>
      {owners?.length > 0 && <OwnerCard owners={updated || []} />}

      {annuitants?.length > 0 && (
        <AnnuitantCard annuitants={annuitants} policyDetail={policyDetail} />
      )}
    </>
  );
}
